import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { RerunWorkflowButton } from '../RerunWorkflowButton';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
export function WorkflowCheckError() {
    const { error } = useWorkflowCheck();
    if (!error) {
        return null;
    }
    const messages = {
        credits: t({
            comment: 'Document workflow check - The company has no more assistant credits',
            message: 'You have insufficient credits on your account to do this action',
        }),
        setup: t({
            comment: 'Document workflow check - There was an error setting up the rules check',
            message: 'Something went wrong when setting up the rules check',
        }),
        streaming: t({
            comment: 'Document workflow check - error when there was an error streaming the response',
            message: 'Something went wrong when running the rules check',
        }),
    };
    return (<Alert appearance="danger" title={t({ comment: 'Document workflow check - Running rules error title', message: 'Error' })} message={messages[error]}>
      <RerunWorkflowButton />
    </Alert>);
}
